module.exports = __webpack_public_path__ + "img/K8.a98d979b.png";